import { DEFAULT_DATE_FORMAT_FNS, StudentRegistration } from '@schooly/api';
import { newDateTimezoneOffset } from '@schooly/utils/date';
import { isAfter, isBefore, parse } from 'date-fns';

export type ValidityInterval = { start: Date; end: Date | null };

const parseDay = (value?: string | null): Date | null =>
  value ? parse(value.slice(0, 10), DEFAULT_DATE_FORMAT_FNS, newDateTimezoneOffset()) : null;

export const getRegistrationValidityIntervals = (
  enrollments: StudentRegistration[],
  schoolYearId: string,
): ValidityInterval[] => {
  const registrations = enrollments.filter((r) => r.school_year.id === schoolYearId);

  const intervals: ValidityInterval[] = [];
  for (const registration of registrations) {
    for (const status of registration.statuses ?? []) {
      if (!status.school_property?.category?.current) continue;
      const start = parseDay(status.applies_from);
      if (!start) continue;
      intervals.push({ start, end: parseDay(status.applies_to) });
    }
  }

  return intervals;
};

export const isDateWithinValidity = (date: Date, intervals: ValidityInterval[]): boolean =>
  intervals.some(({ start, end }) => !isBefore(date, start) && (!end || !isAfter(date, end)));
